import React, {useContext} from "react";
import {IonList} from "@ionic/react";
import {AuthContext} from "../../context/AuthContext";
import {AppButton} from "../../components";
import {useHistory} from "react-router";
import "./cart.styles.css";
import {getLocalStorage, setLocalStorage} from "../../lib/utils/storage.utils";

const Cart = ({setShowPopover, cartPopOver}: any) => {
  const history = useHistory();
  const {
    cartList,
    setCartList,
    validateCartItems,
    removeServiceFromCart,
    isLoggedIn,
  } = useContext(AuthContext);

  const handleRemoveService = (serviceId: number) => {
    removeServiceFromCart(serviceId);
  };

  const handleRemoveFromLocalCart = (cartId: string) => {
    const cartLocalList = getLocalStorage("cos-milano-web-cart");
    const newCartLocalList = cartLocalList.filter(
      (item: any) => item.cartID !== cartId
    );

    setLocalStorage("cos-milano-web-cart", newCartLocalList);
    setCartList(newCartLocalList);
    // setShowPopover({
    //   showPopover: false,
    //   event: undefined,
    // });
  };
  return (
    <IonList className="cart-list">
      {cartList?.length > 0 ? (
        cartList.map((item: any, index: number) => (
          <div key={index} className="flex-justify-between cart-container">
            <span>{item.serviceName}</span>
            <p
              className="cart-remove-icon-button"
              onClick={() => {
                isLoggedIn()
                  ? handleRemoveService(item.cartId)
                  : handleRemoveFromLocalCart(item.cartID);
              }}
            >
              X
            </p>
          </div>
        ))
      ) : (
        <div className="flex-justify-center cart-container">
          Carrello vuoto, sembra che tu non abbia inserito alcun servizio
        </div>
      )}

      <div className="text-center cart-button">
        <AppButton
          block
          buttonType="success"
          onClick={() => {
            if (cartList?.length > 0) {
              setShowPopover({
                showPopover: false,
                event: cartPopOver.event,
              });
              validateCartItems();
            } else {
              setShowPopover({
                showPopover: false,
                event: cartPopOver.event,
              });
              history.push("/servizi");
            }
          }}
        >
          {cartList?.length > 0 ? "CONVALIDA PRATICHE" : "Cerca un servizio"}
        </AppButton>
      </div>
    </IonList>
  );
};
export default Cart;
